import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import { Auth0Plugin } from './auth';
//import { domain, audience, clientId } from '../.auth_config.json';
import 'regenerator-runtime/runtime'
import './registerServiceWorker'

import moment from 'moment'

Object.defineProperty(Vue.prototype, '$moment', { value: moment })
Vue.config.performance = true
Vue.use(CoreuiVue)

const domain = process.env.VUE_APP_AUTH0_DOMAIN;
const audience = process.env.VUE_APP_AUTH0_AUDIENCE;
const clientId = process.env.VUE_APP_AUTH0_CLIENT_ID;


Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  scope: 'login:access',
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});


new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
